import React, { createContext, useContext, useEffect, useState } from "react";
import { isFirebaseConfigured } from "./firebaseConfig";
import {
  resetPassword,
  signIn,
  signOutUser,
  signUp,
  subscribeToAuth,
} from "./authService";

const AuthContext = createContext({
  user: null,
  loading: true,
  configured: false,
  signIn: async () => {},
  signUp: async () => {},
  resetPassword: async () => {},
  signOut: async () => {},
});

export const AuthProvider = ({ children }) => {
  const configured = isFirebaseConfigured();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(configured);

  useEffect(() => {
    if (!configured) {
      setLoading(false);
      return undefined;
    }

    return subscribeToAuth((nextUser) => {
      setUser(nextUser);
      setLoading(false);
    });
  }, [configured]);

  const value = {
    user,
    loading,
    configured,
    signIn,
    signUp,
    resetPassword,
    signOut: signOutUser,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
